import { api } from "../APIClient";
import { ACTION_TYPE } from "reducers/actionType";
import ERROR_TYPE from "utils/errors";
import queryString from "query-string";

const STAGE_1_SAVE_DRAFT_ENDPOINT = "/service/stage/1/save-draft";
const STAGE_2_EMAIL_SUMMARY_ENDPOINT = "/service/stage/2/save-draft";

export const saveDraft = (
  userInput,
  userEmail,
  recommendations_input_hash,
  consent,
  role
) => {
  return (dispatch) => {
    dispatch({
      type: ACTION_TYPE.saveDraft.begin,
      data: {
        loading: true,
        error: null,
      },
    }); // fetching begin
    const queryParams = queryString.stringify({ consent, role });
    return api
      .post(`${STAGE_1_SAVE_DRAFT_ENDPOINT}?${queryParams}`, {
        email_address: userEmail,
        recommendations_input_hash: recommendations_input_hash,
        ...userInput,
      })
      .then((response) => {
        dispatch({
          type: ACTION_TYPE.saveDraft.success,
          data: {
            loading: false,
            error: null,
          },
        });
        const { recommendations_input_hash } = response.data;
        dispatch({
          type: ACTION_TYPE.hash,
          data: { recommendations_input_hash: recommendations_input_hash },
        });
      })
      .catch((error) => {
        const { response } = error;
        let errorType = null;
        let errors = null;

        if (!response) {
          errorType = ERROR_TYPE.network;
        } else {
          const { status } = response;
          if (400 <= status && status < 500) {
            errorType = ERROR_TYPE.client;
          } else {
            errorType = ERROR_TYPE.server;
          }
          errors = response.data.errors;
        }
        dispatch({
          type: ACTION_TYPE.saveDraft.failure,
          data: {
            loading: false,
            error: {
              errorType: errorType,
              errors: errors,
            },
          },
        });
      });
  };
};

export const emailSummary = (
  userEmail,
  recommendations_input_hash,
  eligibility_input_hash,
  consent,
  role
) => {
  return (dispatch) => {
    dispatch({
      type: ACTION_TYPE.emailSummary.begin,
      data: {
        loading: true,
        error: null,
      },
    });
    const queryParams = queryString.stringify({ consent, role });
    return api
      .post(`${STAGE_2_EMAIL_SUMMARY_ENDPOINT}?${queryParams}`, {
        email_address: userEmail,
        recommendations_input_hash: !!recommendations_input_hash
          ? recommendations_input_hash
          : null,
        eligibility_input_hash: eligibility_input_hash, // must exist
      })
      .then((response) => {
        const { recommendations_input_hash, eligibility_input_hash } =
          response.data;
        dispatch({
          type: ACTION_TYPE.emailSummary.begin,
          data: {
            loading: false,
            error: null,
          },
        });
        dispatch({
          type: ACTION_TYPE.hash,
          data: {
            recommendations_input_hash: recommendations_input_hash, // ok to be undefined
            eligibility_input_hash: eligibility_input_hash,
          },
        });
      })
      .catch((error) => {
        const { response } = error;
        let errorType = null;
        let errors = null;

        if (!response) {
          errorType = ERROR_TYPE.network;
        } else {
          const { status } = response;
          if (400 <= status && status < 500) {
            errorType = ERROR_TYPE.client;
          } else {
            errorType = ERROR_TYPE.server;
          }
          errors = response.data.errors;
        }

        dispatch({
          type: ACTION_TYPE.emailSummary.failure,
          data: {
            loading: false,
            error: {
              errorType: errorType,
              errors: errors,
            },
          },
        });
      });
  };
};
